import { render } from "./AboutPage.vue?vue&type=template&id=d407bed4&scoped=true"
const script = {}

import "./AboutPage.vue?vue&type=style&index=0&id=d407bed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d407bed4"]])

export default __exports__